// extracted by mini-css-extract-plugin
module.exports = {"splashHolder":"Splash_splashHolder__AIB8h","logo":"Splash_logo__e-Wm1","message":"Splash_message__2_4nh","loader":"Splash_loader__3HZVZ"};